import useSWR from 'swr';
import { orderTrackingFetcher } from '@/data/Content/_Order';
import { DATA_KEY_ORDER_TRACKING } from '@/data/constants/dataKey';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';

export const useTrackingOrder = (orderId?: string) => {
	const router = useNextRouter();
	const { settings } = useSettings();
	const params = useExtraRequestParameters();
	const { langId, storeId } = getClientSideCommon(settings, router);

	const { data: tracking, ...trackingQuery } = useSWR(
		storeId && orderId
			? [
					{
						storeId: settings.storeId,
						orderId,
						query: { langId },
					},
					DATA_KEY_ORDER_TRACKING,
			  ]
			: null,
		async ([{ storeId, orderId, query }]) =>
			orderTrackingFetcher(true)(orderId, storeId, query, params)
	);

	return {
		tracking,
		...trackingQuery,
	};
};
